export const FILE_EXTENSION = /\.[^.]+$/
